export default __webpack_public_path__ + "static/MXW Register-6a78c426e52cddd0e0c143bbeea757f3.webp";